import Ajax from "Utils/ajax";
export const getAllCompanyList = (data) => Ajax.post('hr/getAllCompanyList',data);
export const getAllStaffAttendanceForMonth = (data) => Ajax.post('hr/getAllStaffAttendanceForMonth',data);